import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timezoneCleanBulk',
    standalone: false
})
export class TimezoneCleanBulkPipe implements PipeTransform {
  transform(timezones: Array<{ label: string, value: string }>): Array<{ label: string, value: string }> {
    const timeOffsetRegExp = /[^(GMT +].*(?=\))/;
    const nameRegExp = /[^\)]*([a-zA-Z?\/\d])$/;

    const mappedTimezones = timezones.map(timezone => {
      return {label: timezone.label.replace('_', ' '), value: timezone.value};
    });

    return mappedTimezones.sort((a, b) => {
      const timezoneAOffset = Number(timeOffsetRegExp.exec(a.label)[0].replace(':', '.'));
      const timezoneBOffset = Number(timeOffsetRegExp.exec(b.label)[0].replace(':', '.'));

      // If both timezones are the same: Sort by Alpha
      if (timezoneAOffset === timezoneBOffset) {
        return nameRegExp.exec(a.label)[0].trim() > nameRegExp.exec(b.label)[0].trim() ? 1 : -1;
      }
      // If both timezones are negative: Invert the sort logic
      if (timezoneAOffset < 0 && timezoneBOffset < 0) {
        return (timeOffsetRegExp.exec(a.label)[0] < timeOffsetRegExp.exec(b.label)[0] ? 1 : -1);
      }
      // Sort by GMT offset
      return (timeOffsetRegExp.exec(a.label)[0] > timeOffsetRegExp.exec(b.label)[0] ? 1 : -1);
    });
  }
}
